<template>
    <div class="row child-component">
        <div class="col-lg-7 col-md-8 col-sm-8 col-xs-6 mx-auto">
            <div class="d-block row col-lg-8 mx-auto">
                <div class="fieldborder mt-3">
                    <label>Is this a change in existing reporting entity?</label>
                    <b-form-group>
                        <b-form-radio-group class="mx-2" id="IsChangeInReportingEntity"
                            v-model="ReportingEntity.IsChangeInReportingEntity" name="IsChangeInReportingEntity">
                            <b-form-radio :value="true">Yes</b-form-radio>
                            <b-form-radio :value="false">No (This is a brand new reporting entity)</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </div>
                 <template v-if="ReportingEntity.IsChangeInReportingEntity === false">
                <div class="fieldborder mt-3">
                    <label>Is there media associated with this new reporting entity?</label>
                    <b-form-group>
                        <b-form-radio-group class="mx-2" id="IsMediaAssociated" v-model="ReportingEntity.IsMediaAssociated"
                            name="IsMediaAssociated">
                            <b-form-radio :value="true">Yes</b-form-radio >
                            <b-form-radio :value="false">No</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </div>
                <div class="fieldborder mt-2" v-if="ReportingEntity.IsMediaAssociated === true">
                    <label>Is there an existing media office already set up in MO?
                        <svg style="margin-bottom: 1px; margin-left: 5px" width="9px" height="9px" viewBox="0 0 9 9"
                            version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            v-b-tooltip.hover.v-dark.right.html="'If there is media associated with this new reporting entity, but the media office has not yet been created, once this request is submitted, approved, and completed, a notification will go out to the Financial Systems team to create the media office.'
                                ">
                            <g id="LATEST" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <path
                                    d="M4.5,0 C2.014875,0 0,2.014875 0,4.5 C0,6.985125 2.014875,9 4.5,9 C6.985125,9 9,6.985125 9,4.5 C8.997375,2.016 6.984,0.002625 4.5,0 Z M4.59375,1.875 C4.90425,1.875 5.15625,2.127 5.15625,2.4375 C5.15625,2.748 4.90425,3 4.59375,3 C4.28325,3 4.03125,2.748 4.03125,2.4375 C4.03125,2.127 4.28325,1.875 4.59375,1.875 Z M5.4375,6.9375 L3.9375,6.9375 C3.7305,6.9375 3.5625,6.7695 3.5625,6.5625 C3.5625,6.3555 3.7305,6.1875 3.9375,6.1875 L4.21875,6.1875 C4.2705,6.1875 4.3125,6.1455 4.3125,6.09375 L4.3125,4.40625 C4.3125,4.3545 4.2705,4.3125 4.21875,4.3125 L3.9375,4.3125 C3.7305,4.3125 3.5625,4.1445 3.5625,3.9375 C3.5625,3.7305 3.7305,3.5625 3.9375,3.5625 L4.3125,3.5625 C4.726875,3.5625 5.0625,3.898125 5.0625,4.3125 L5.0625,6.09375 C5.0625,6.1455 5.1045,6.1875 5.15625,6.1875 L5.4375,6.1875 C5.6445,6.1875 5.8125,6.3555 5.8125,6.5625 C5.8125,6.7695 5.6445,6.9375 5.4375,6.9375 Z"
                                    id="info" fill="#00A1D2" fill-rule="nonzero"></path>
                            </g>
                        </svg>
                    </label>
                    <b-form-group>
                        <b-form-radio-group class="mx-2" id="IsMediaOfficeSetUpInMO" v-model="ReportingEntity.IsMediaOfficeSetUpInMO"
                            name="IsMediaOfficeSetUpInMO">
                            <b-form-radio :value="true">Yes</b-form-radio>
                            <b-form-radio :value="false">No</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </div>
                <div class="fieldborder mt-2">
                    <label>Will this reporting entity be required in Reach?
                        <svg style="margin-bottom: 1px; margin-left: 5px" width="9px" height="9px" viewBox="0 0 9 9"
                            version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            v-b-tooltip.hover.v-dark.right.html="'Will resources need to be hired under this reporting entity?'
                                ">
                            <g id="LATEST" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <path
                                    d="M4.5,0 C2.014875,0 0,2.014875 0,4.5 C0,6.985125 2.014875,9 4.5,9 C6.985125,9 9,6.985125 9,4.5 C8.997375,2.016 6.984,0.002625 4.5,0 Z M4.59375,1.875 C4.90425,1.875 5.15625,2.127 5.15625,2.4375 C5.15625,2.748 4.90425,3 4.59375,3 C4.28325,3 4.03125,2.748 4.03125,2.4375 C4.03125,2.127 4.28325,1.875 4.59375,1.875 Z M5.4375,6.9375 L3.9375,6.9375 C3.7305,6.9375 3.5625,6.7695 3.5625,6.5625 C3.5625,6.3555 3.7305,6.1875 3.9375,6.1875 L4.21875,6.1875 C4.2705,6.1875 4.3125,6.1455 4.3125,6.09375 L4.3125,4.40625 C4.3125,4.3545 4.2705,4.3125 4.21875,4.3125 L3.9375,4.3125 C3.7305,4.3125 3.5625,4.1445 3.5625,3.9375 C3.5625,3.7305 3.7305,3.5625 3.9375,3.5625 L4.3125,3.5625 C4.726875,3.5625 5.0625,3.898125 5.0625,4.3125 L5.0625,6.09375 C5.0625,6.1455 5.1045,6.1875 5.15625,6.1875 L5.4375,6.1875 C5.6445,6.1875 5.8125,6.3555 5.8125,6.5625 C5.8125,6.7695 5.6445,6.9375 5.4375,6.9375 Z"
                                    id="info" fill="#00A1D2" fill-rule="nonzero"></path>
                            </g>
                        </svg>
                    </label>
                    <b-form-group>
                        <b-form-radio-group class="mx-2" id="IsRequiredInReach" v-model="ReportingEntity.IsRequiredInReach"
                            name="IsRequiredInReach">
                            <b-form-radio :value="true">Yes</b-form-radio>
                            <b-form-radio :value="false">No</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </div>
                </template>                           
                <div v-if="ReportingEntity.IsChangeInReportingEntity === true">
                    <div class="fieldborder mt-2">
                        <label>Please indicate the current HFM entity that this maps to</label>
                        <b-form-input autocomplete="off" id="CurrentHFMEntity" class="omniipclass" v-model="ReportingEntity.CurrentHFMEntity" placeholder="Current HFM Entity"></b-form-input>
                    </div>
                    <div class="fieldborder pt-2">
                        <label>Also, please indicate any existing alternate subsets or roll ups you need this removed from</label>
                        <b-textarea :maxlength="100" v-model="ReportingEntity.ExistingRollupsToRemove" @blur="SetDirty()" @focus="ResetDirty()" rows="5">
                        </b-textarea>
                    </div>
                </div>
                 <div class="fieldborder pt-2">
                    <label>If you would like this to be included in any alternate subsets or roll ups please indicate here</label>
                    <b-textarea :maxlength="100" v-model="ReportingEntity.AlternateSubsetsOrRollups" @blur="SetDirty()" @focus="ResetDirty()" rows="5">
                    </b-textarea>
                </div> 
            </div>
        </div>
        <div class="form-group pt-60 text-right  footer-buttons" style="padding-right:96px !important;">
            <button class="btn btn-link text-uppercase" @click="Cancel()">
                CANCEL
            </button>
            <button class="text-uppercase btn custom-button btn-primary" @click="Previous()">
                BACK
            </button>
            <button class="text-uppercase btn custom-button btn-primary" @click="Next()" :disabled="this.$v.$invalid">
                NEXT
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required , requiredIf } from "vuelidate/lib/validators";
export default {
    props: {
        id: {
            type: Number,
            required: false,
        },
        isDraft: {
            type: Boolean,
            required: false
        }
    },
    validations: {
        ReportingEntity: {
            IsMediaAssociated: {
               required: requiredIf(function(){
                    return this.ReportingEntity.IsChangeInReportingEntity === false
                }),
            },
            IsMediaOfficeSetUpInMO: {
                required: requiredIf(function(){
                    return this.ReportingEntity.IsMediaAssociated === true
                }),
            },
            IsRequiredInReach: {
              required: requiredIf(function(){
                    return this.ReportingEntity.IsChangeInReportingEntity === false
                }),
            },
            IsChangeInReportingEntity: {
                required
            },
            AlternateSubsetsOrRollups: {
                required
            },
            CurrentHFMEntity: {
                required: requiredIf(function(){
                    return this.ReportingEntity.IsChangeInReportingEntity === true
                }),
            },
            ExistingRollupsToRemove: {
                required: requiredIf(function(){
                    return this.ReportingEntity.IsChangeInReportingEntity == true
                }),
            },
        }
    },
    computed: {
        IsEdit() {
            return this.id && !isNaN(this.id) && parseInt(this.id) > 0 ? true : false;
        },
        ...mapGetters('reportingEntity', {
            ReportingEntity: 'ReportingEntity',
        }),
    },
    mounted() {
    },
    activated() {
        this.$parent.$emit("stepInitiated", this.$route.meta.tabIndex);
    },
    methods: {
        SetDirty(propertyName) {
            this.$v.ReportingEntity[propertyName].$touch();

        },
        ResetDirty(propertyName) {
            this.$v.ReportingEntity[propertyName].$reset();
        },
        Next() {
            this.$parent.$emit("stepChanged", this.$route.meta.tabIndex);
            if (this.id) {
                this.$router.push({
                    name: "Reporting Entity Review",
                    params: {
                        id: this.id,
                        isDraft: this.isDraft
                    }
                });
            } else {
                this.$router.push({
                    name: "Reporting Entity Review"
                });
            }
        },
        Cancel() {
            this.$router.push("/ReportingEntity");
        },
        Previous() {
            if (this.id) {
                this.$router.push({
                    name: "Agency/HFM Info",
                    params: {
                        id: this.id,
                        isDraft: this.isDraft
                    }
                });
            } else {
                this.$router.push({
                    name: "Agency/HFM Info"
                });
            }
        },
    },
    watch: {
        "ReportingEntity.IsMediaAssociated": function (val) {
            if (val === false) {
                this.ReportingEntity.IsMediaOfficeSetUpInMO = null;
            }
        },
        "ReportingEntity.IsChangeInReportingEntity": function (val) {
            if (val === false) {
                this.ReportingEntity.CurrentHFMEntity = null;
                this.ReportingEntity.ExistingRollupsToRemove = null;
            } else if (val === true) {
                this.ReportingEntity.IsMediaAssociated = null;
                this.ReportingEntity.IsMediaOfficeSetUpInMO = null;
                this.ReportingEntity.IsRequiredInReach = null;
            }
        },
    },
}
</script>
<style scoped>
label {
    line-height: normal;
}
::v-deep .custom-control-label {
    text-transform: none !important;
}
</style>
